import Environment from '../../constants/environment';
//import ContratoRepresentanteFreeModal from "./ContratoRepresentanteModal";
//import SipGasDetailsExtend from "./SipGasDetailsExtend";

import React, { forwardRef } from "react";
import Reflux from "reflux";
import axios from 'axios';
import memoize from 'memoize-one';
//import DatePicker from "react-datepicker";
import { validateSpanishId } from 'spain-id'
//import FormData from 'form-data';
// reactstrap components
import {
    Card, Container, Row, CardTitle, CardBody, Label,
    FormGroup,
    Input, FormText,
    Form, Col, Button,
    UncontrolledTooltip, CardHeader, Collapse
} from "reactstrap";
import {
    Link,
    useRouteMatch
} from 'react-router-dom';
import LoadingOverlay from "react-loading-overlay";
import { CSVLink, CSVDownload } from "react-csv";

// core components
import Header from "../../components/Headers/Header";

import { withApollo } from "react-apollo";
import moment from "moment";
import 'moment/locale/es'

import ReactBSAlert from "react-bootstrap-sweetalert";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import GetUserData from "../../components/User/GetUserData";
import { UserStore } from "../../store/UserStore";
import DataTable from 'react-data-table-component';
import Checkbox from '@material-ui/core/Checkbox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import memoize from 'memoize-one';
import CircularProgress from '@material-ui/core/CircularProgress';
import { saveAs } from 'file-saver';
import SipsOption from "../../components/Sips/SipsOption";
import SipsGasOption from "../../components/SipsGas/SipsGasOption";

var DatePicker = require("reactstrap-date-picker");

const FileDownload = require('js-file-download');
const formato = require('xml-formatter');
const spanishDayLabels = ['Dom', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sab'];
const spanishMonthLabels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const notify = () => toast.success(
    "Producto actualizado correctamente",
    {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

const notifyErrorRep = () => toast.error(
    "Debes completar los datos del producto",
    {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });




const hint = <span>My custom hint</span>;
const note = <span>My custom note</span>;
const sortIcon = <ArrowDownward />;

const columnsDatosProductosLuz = [

    { selector: row => row.nombreOferta, name: 'NOMBRE OFERTA', sortable: true, width: '220px', format: (row => capitalize(row.nombreOferta)) },
    { selector: row => row.nombreComercializadora, name: 'COMERCIALIZADORA', sortable: true, width: '240px', center: true, format: (row => capitalize(row.nombreComercializadora)) },
    { selector: row => row.TarifaDesc, name: 'Tarifa', sortable: true, width: '210px', center: true, format: (row => capitalize(row.TarifaDesc)) },
    { selector: row => row.esActiva, name: 'ACTIVA', sortable: true, width: '100px', center: true },
    { selector: row => row.precioTEP1, name: 'Precio E P1', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTEP2, name: 'Precio E P2', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTEP3, name: 'Precio E P3', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTEP4, name: 'Precio E P4', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTEP5, name: 'Precio E P5', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTEP6, name: 'Precio E P6', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP1, name: 'Precio P P1', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP2, name: 'Precio P P2', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP3, name: 'Precio P P3', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP4, name: 'Precio P P4', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP5, name: 'Precio P P5', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTP6, name: 'Precio P P6', sortable: true, width: '200px', center: true },
];


const columnsDatosProductosGas = [

    { selector: row => row.nombreOferta, name: 'NOMBRE OFERTA', sortable: true, width: '220px', format: (row => capitalize(row.nombreOferta)) },
    { selector: row => row.nombreComercializadora, name: 'COMERCIALIZADORA', sortable: true, width: '240px', center: true, format: (row => capitalize(row.nombreComercializadora)) },
    { selector: row => row.TarifaDesc, name: 'Tarifa', sortable: true, width: '210px', center: true, format: (row => capitalize(row.TarifaDesc)) },
    { selector: row => row.esActiva, name: 'ACTIVA', sortable: true, width: '100px', center: true },
    { selector: row => row.precioTE1, name: 'Precio E P1', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTE2, name: 'Precio E P2', sortable: true, width: '200px', center: true },
    { selector: row => row.precioTFijo, name: 'Precio T Fijo', sortable: true, width: '200px', center: true }
];

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.toLowerCase().charAt(0).toUpperCase() + s.slice(1)
}

const customStyles = {
    headRow: {
        style: {
            border: 'none',

        },
    },
    headCells: {
        style: {
            color: '#202124',
            fontSize: '12px',
            fontWeight: 'bold',
            wordBreak: 'break-word',
            paddingLeft: '8px',
            paddingRight: '8px',
            minWidth: '55px'

        },
    },
    cells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            minWidth: '55px',
            wordBreak: 'break-word',
            fontFamily: '"Open Sans", sans-serif;'
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 250, 250)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
            fontSize: '12px',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};


const Circular = () => (
    // we need to add some padding to circular progress to keep it from activating our scrollbar
    <div style={{ padding: '24px' }}>
        <CircularProgress size={75} />
    </div>
);





class Producto extends Reflux.Component<any, any> {
    public maxFileSize = 3;
    public fileInput: any = null;
    public lecturasRef: any = [];
    public inputEl: any = null;
    public formRef: any = null;
    public validFileExtensions = ["jpg", "jpeg", "png"];
    lastFilters = {};
    state = {
        filters: {
            nombreProductoSearch: "",
            idSearch: "",
            cifSearch: "",
            tipoContratoSearch: "L",
            codeComercializadora: "",
            tipoEstadoSearch: "",
            productoHasta: "",
            productoDesde: ""
        },
        UserStore: {},
        nombreFichero: "",
        isLoading: false,
        copiedText: null,
        currentPage: 0,
        pageSize: 0,
        pageCount: 0,
        count: 0,
        contrato: "",
        tipoContrato: "",
        productoDetailTotal: [],
        productoSeleccionado: false,
        idProducto: '',
        productoDetail: {
            TarifaDesc: "",
            atencionCliente: "",
            caracteristicas: "",
            coIncluido: false,
            companyId: 0,
            componentesRegulados: false,
            condicionesPenalizacion: "",
            condicionesRevisionPrecios: "",
            consumoMaximoElectricidad: "0",
            consumoMaximoGas: "0",
            consumoMinimoElectricidad: "0",
            consumoMinimoGas: "0",
            descuentoTE: "0",
            descuentoTP: "0",
            esActiva: false,
            facturacion: "",
            id: "",
            idComercializadora: "",
            infoAdicional: "",
            limitaciones: "",
            nombreComercializadora: "",
            nombreOferta: "",
            nombreDocumentoContrato:"",
            ofertaInternet: false,
            ofertaOficina: false,
            ofertaTel: false,
            peaje: "",
            penalizacionMaxElec: "0",
            penalizacionMaxGas: "0",
            periocidadRevisionPrecios: "",
            periodoValidez: "",
            periodoValidezDesde: "",
            periodoValidezHasta: "",
            potenciaMaximaElectricidad: "0",
            potenciaMinimaElectricidad: "0",
            precioAlquilerContadore: "0",
            precioServicios: "0",
            precioTEP1: "0",
            precioTEP2: "0",
            precioTEP3: "0",
            precioTEP4: "0",
            precioTEP5: "0",
            precioTEP6: "0",
            precioTP1: "0",
            precioTP2: "0",
            precioTP3: "0",
            precioTP4: "0",
            precioTP5: "0",
            precioTP6: "0",
            precioTPPeriodo: "0",
            precioTPTipo: "0",
            serviciosNoObligatorios: "",
            serviciosObligatorios: false,
            tarifaATR: "",
            verde: true,
            webContrato: "",
            webOferta: "",
            fechaAltaProducto: '',
            fechaBajaProducto: '',
            tipoProducto: '',
            precioTE1: "0",
            precioTE2: "0",
            precioTFijo: "0",
            factork:"0",
            comisionContratoNuevo:"0",
            comisionContratoRenovacion:"0",
            comisionConsumoAgente1:"0",
            comisionConsumoAgente2:"0",
            comisionConsumoAdmin:"0",
            comisionGOAgente1: "0",
            comisionGOAgente2:"0"
        },
        formProducto: {
            TarifaDesc: "",
            atencionCliente: "",
            caracteristicas: "",
            coIncluido: false,
            companyId: 0,
            componentesRegulados: false,
            condicionesPenalizacion: "",
            condicionesRevisionPrecios: "",
            consumoMaximoElectricidad: "0",
            consumoMaximoGas: "0,0",
            consumoMinimoElectricidad: "0",
            consumoMinimoGas: "0",
            descuentoTE: "0",
            descuentoTP: "0",
            esActiva: false,
            facturacion: "",
            id: "",
            idComercializadora: "",
            infoAdicional: "",
            limitaciones: "",
            nombreComercializadora: "",
            nombreOferta: "",
            nombreDocumentoContrato:"",
            ofertaInternet: false,
            ofertaOficina: false,
            ofertaTel: false,
            peaje: "",
            penalizacionMaxElec: "0",
            penalizacionMaxGas: "0",
            periocidadRevisionPrecios: "",
            periodoValidez: "",
            periodoValidezDesde: "",
            periodoValidezHasta: "",
            potenciaMaximaElectricidad: "0",
            potenciaMinimaElectricidad: "0",
            precioAlquilerContadore: "0",
            precioServicios: "0",
            precioTEP1: "0",
            precioTEP2: "0",
            precioTEP3: "0",
            precioTEP4: "0",
            precioTEP5: "0",
            precioTEP6: "0",
            precioTP1: "0",
            precioTP2: "0",
            precioTP3: "0",
            precioTP4: "0",
            precioTP5: "0",
            precioTP6: "0",
            precioTPPeriodo: "0",
            precioTPTipo: "0",
            serviciosNoObligatorios: "",
            serviciosObligatorios: false,
            tarifaATR: "",
            verde: true,
            webContrato: "",
            webOferta: "",
            fechaAltaProducto: '',
            fechaBajaProducto: '',
            tipoProducto: '',
            precioTE1: "0",
            precioTE2: "0",
            precioTFijo: "0",
            factork:"0",
            comisionContratoNuevo:"0",
            comisionContratoRenovacion:"0",
            comisionConsumoAgente1:"0",
            comisionConsumoAgente2:"0",
            comisionConsumoAdmin:"0",
            comisionGOAgente1: "0",
            comisionGOAgente2:"0"
        },

        companyIdUser: '',
        companyNameGlobal: '',
        userGroupId: 1000,
        userId: '',
        esAgencia: false,
        esComercializadora: false,
        esAdFincas: false,
        saveDataProducto: false,
        updateDataProducto: false,
        saveProductoButtonDisabled: true,
        updateProductoButtonDisabled: true,
        saveXMLButtonDisabled: true,
        buscarButtonDisabled: true,
        CIFRepreError: false,
        inputDisabled: true,
        show: false,
        imgCollection: [],
        saveButtonDisabled: true,
        showFilters: true,
        toggledClearRows: false,
        cupsError: false,
        cifError: false,
        locale: 'es',
        inputNombreProductoDisabled: false,
        inputCifDisabled: false,
        inputIdDisabled: true,
        productoDesde: '',
        productoHasta: '',
        fechaAltaProducto: '',
        fechaBajaProducto: '',
        periodoValidezHasta: '',
        periodoValidezDesde: '',
        inputDisabledP3456: false,
        inputDisabledE456: false,
        alert: null


    };

    sipsCSVData: any = [];
    viewSipsConsumoAnualCSVData: any = [];
    sipsConsumosCSVData: any = [];
    sipstotal: any = [];





    constructor(props) {
        super(props);
        this.store = UserStore;
        this.formRef = React.createRef();

    }


    componentWillReceiveProps() {

        const usuario: any = JSON.parse(JSON.stringify(this.state.UserStore['data']))

        console.log('VALORES DE USUARIO EN componentWillReceiveProps')
        console.log(usuario)

        const companyNameGlobal = usuario.company;
        const companyIdUser = usuario.companyId;

        const userGroupId = usuario.user_group_id
        const userId = usuario.id
        const esComercializadora = usuario.comercializadora
        const esAgencia = usuario.agencia
        const esAdFincas = usuario.adFincas



        if (userGroupId === 1000) {
            this.setState({
                activeUser: true
            })
        };

        this.setState({
            companyNameGlobal,
            companyIdUser,
            userGroupId,
            userId,
            esComercializadora,
            esAgencia,
            esAdFincas

        });
    };


///////////////////////////////////////////////////////////////////////////////////////////////////


hideAlert = () => {
    this.setState({
        alert: null
    });
};

warningAlert = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Error en la base de datos"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="warning"
                confirmBtnText="Ok"
                btnSize=""
            >
                Existe un error en la Base de datos.
 </ReactBSAlert>
        )
    });
};

warningAlertNIF = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="No existen registros que cumplan los requisitos"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="warning"
                confirmBtnText="Ok"
                btnSize=""
            >
                Revise los requisitos introducidos
 </ReactBSAlert>
        )
    });
};

warningAlertFiltros = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Existen campos obligatorios sin información"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="warning"
                confirmBtnText="Ok"
                btnSize=""
            >
                Revise los datos introducidos
 </ReactBSAlert>
        )
    });
};

confirmAlertSave = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="¿Desea crear el producto?"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.onSave()}
                showCancel
                confirmBtnBsStyle="secondary"
                confirmBtnText="Cancelar"
                cancelBtnBsStyle="danger"
                cancelBtnText="Guardar"
                btnSize=""
            >
                No se podrá volver atrás!
        </ReactBSAlert>
        )
    });
};

confirmAlertUpdate = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="¿Desea actualizar los datos del producto?"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.onUpdate()}
                showCancel
                confirmBtnBsStyle="secondary"
                confirmBtnText="Cancelar"
                cancelBtnBsStyle="danger"
                cancelBtnText="Actualizar"
                btnSize=""
            >
                No se podrá volver atrás!
        </ReactBSAlert>
        )
    });
};

successAlert = () => {
    this.setState({
        alert: (
            <ReactBSAlert
                success
                style={{ display: "block", marginTop: "-100px" }}
                title="Correcto"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="success"
                confirmBtnText="Ok"
                btnSize=""
            >
                Producto actualizado correctamente
    </ReactBSAlert>
        )
    });
};



//////////////////////////////////////////////////////////////////////////////////////7






    onChangeFieldSearch = (event) => {
        event.persist()
        const name = event.target.name;
        let value = event.target.value;
        const filters = this.state.filters;
        console.log(event)
        console.log(name)
        console.log(value)
        filters[name] = value;
        /* if (event.target.type === "select-one" && value === "0") {
           delete filters[name];
         }

         if (value === "" || value === null) {
           delete filters[name];
         }
*/




        if (event.target.name === 'nombreProductoSearch' && event.target.value.length == 0) {
            this.setState({
                cupsError: false,
                buscarButtonDisabled: true,
                inputCifDisabled: false,
                inputNombreProductoDisabled: false,
                inputIdDisabled: false
            })
        } else if (event.target.name === 'nombreProductoSearch' && event.target.value.length > 0) {

            this.setState({
                inputCifDisabled: true,
                inputIdDisabled: true,
                buscarButtonDisabled: false

            })

        }



        if (event.target.name === 'idSearch' && event.target.value.length == 0) {
            this.setState({
                buscarButtonDisabled: true,
                inputCifDisabled: false,
                inputNombreProductoDisabled: false,
                inputIdDisabled: false
            })
        } else if (event.target.name === 'idSearch' && event.target.value.length > 0) {

            this.setState({

                inputCifDisabled: true,
                inputNombreProductoDisabled: true,
                buscarButtonDisabled: false
            })
        }


        if (event.target.name == 'tipoContratoSearch' || event.target.name == 'tipoEstadoSearch' || event.target.name == 'productoDesde' || event.target.name == 'productoHasta') {
            this.setState({
                buscarButtonDisabled: false,
                inputCifDisabled: false,
                inputNombreProductoDisabled: false,
                inputIdDisabled: false
            })
        }

        this.setState({ filters });

    }



    onChangeFieldProducto = (event) => {
        event.persist()

        var formData = { ...this.state.formProducto };
        var target = event.target;
        var value =
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value;
        const name = event.target.name;
        console.log(event.target.name)
        console.log(event.target.value)

        const nameFilters = ['nombreComercializadora', 'nombreOferta','nombreDocumentoContrato', 'TarifaDesc', 'companyId', 'esActiva', 'fechaAltaProducto', 'fechaBajaProducto', 'id', 'idComercializadora', 'tarifaATR', 'peaje', 'coIncluido', 'verde', 'facturacion', 'precioTEP1', 'precioTEP2', 'precioTEP3', 'precioTEP5', 'precioTEP4', 'precioTEP6', 'precioTP1', 'precioTP2', 'precioTP3',
            'precioTP4', 'precioTP5', 'precioTP6', 'precioTPPeriodo', 'precioTPTipo', 'periocidadRevisionPrecios', 'periodoValidezDesde', 'periodoValidezHasta', 'ofertaInternet', 'ofertaOficina', 'ofertaTel',
            'serviciosObligatorios', 'infoAdicional', 'caracteristicas', 'comisionContratoNuevo','comisionContratoRenovacion','comisionConsumoAgente1','comisionConsumoAgente2','comisionConsumoAdmin','comisionGOAgente1','comisionGOAgente2'];

        if (this.state.productoSeleccionado) {

            if (nameFilters.indexOf(event.target.name) != -1) {
                this.setState({ updateDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: true,
                    updateProductoButtonDisabled: false
                })
            }


            if (event.target.name == 'idComercializadora') {
                //this.setState ({productoDetail.nombreOferta : event.target.value});
                this.setState({ updateDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: true,
                    updateProductoButtonDisabled: false
                })
                const NombreComercializadora = event.target.selectedOptions[0].label

                console.log(formData)
                formData['nombreComercializadora'] = NombreComercializadora;
                //if (value === "" || value === null) {
                //    formData[name] = 0;
                //}
                this.setState({ formProducto: formData });
            }


            if (event.target.name == 'tarifaATR') {
                //this.setState ({productoDetail.nombreOferta : event.target.value});
                this.setState({ updateDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: true,
                    updateProductoButtonDisabled: false
                })
                const NombreTarifa = event.target.selectedOptions[0].label

                console.log(formData)
                formData['TarifaDesc'] = NombreTarifa;
                //if (value === "" || value === null) {
                //    formData[name] = 0;
                //}
                this.setState({ formProducto: formData });
            }

        } else {



            if (nameFilters.indexOf(event.target.name) != -1) {
                this.setState({ saveDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: false,
                    updateProductoButtonDisabled: true
                })
            }

            if (event.target.name == 'idComercializadora') {
                //this.setState ({productoDetail.nombreOferta : event.target.value});
                this.setState({ saveDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: false,
                    updateProductoButtonDisabled: true
                })
                const NombreComercializadora = event.target.selectedOptions[0].label

                console.log(formData)
                formData['nombreComercializadora'] = NombreComercializadora;
                //if (value === "" || value === null) {
                //    formData[name] = 0;
                //}
                this.setState({ formProducto: formData });
            }


            if (event.target.name == 'tarifaATR') {
                //this.setState ({productoDetail.nombreOferta : event.target.value});
                this.setState({ saveDataProducto: true });
                this.setState({
                    saveProductoButtonDisabled: false,
                    updateProductoButtonDisabled: true
                })
                const NombreTarifa = event.target.selectedOptions[0].label

                console.log(formData)
                formData['TarifaDesc'] = NombreTarifa;
                //if (value === "" || value === null) {
                //    formData[name] = 0;
                //}
                this.setState({ formProducto: formData });
            }

        }

        if (value == 'Selecciona...') {

            value = ""
        }


        if (value === "true" || value == "false") {
            value = JSON.parse(value);
        }


        console.log(formData)
        formData[name] = value;
        //if (value === "" || value === null) {
        //    formData[name] = 0;
        //}
        this.setState({ formProducto: formData });

    };


    showFiltersToggle = () => {
        const showFilters = !this.state.showFilters;

        this.setState({ showFilters });
    };

    getFilterIcon = () => {
        return this.state.showFilters ? "ni-bold-up" : "ni-bold-down";
    };



    clearForm = () => {
        const filters = {};
        this.setState({
            filters: {
                nombreProductoSearch: '',
                cifSearch: '',
                idSearch: ''
            },
            inputCifDisabled: false,
            inputNombreProductoDisabled: false,
            inputIdDisabled: false,
            inputDisabled: false,
            buscarButtonDisabled: true,
            productoSeleccionado: false,
            productoDetailTotal: [],
            formProducto: {
                TarifaDesc: "",
                atencionCliente: "",
                caracteristicas: "",
                coIncluido: false,
                companyId: 0,
                componentesRegulados: false,
                condicionesPenalizacion: "",
                condicionesRevisionPrecios: "",
                consumoMaximoElectricidad: "0",
                consumoMaximoGas: "0,0",
                consumoMinimoElectricidad: "0",
                consumoMinimoGas: "0",
                descuentoTE: "0",
                descuentoTP: "0",
                esActiva: false,
                facturacion: "",
                id: "",
                idComercializadora: "",
                infoAdicional: "",
                limitaciones: "",
                nombreComercializadora: "",
                nombreOferta: "",
                nombreDocumentoContrato:"",
                ofertaInternet: false,
                ofertaOficina: false,
                ofertaTel: false,
                peaje: "",
                penalizacionMaxElec: "0",
                penalizacionMaxGas: "0",
                periocidadRevisionPrecios: "",
                periodoValidez: "",
                periodoValidezDesde: "",
                periodoValidezHasta: "",
                potenciaMaximaElectricidad: "0",
                potenciaMinimaElectricidad: "0",
                precioAlquilerContadore: "0",
                precioServicios: "0",
                precioTEP1: "0",
                precioTEP2: "0",
                precioTEP3: "0",
                precioTEP4: "0",
                precioTEP5: "0",
                precioTEP6: "0",
                precioTP1: "0",
                precioTP2: "0",
                precioTP3: "0",
                precioTP4: "0",
                precioTP5: "0",
                precioTP6: "0",
                precioTPPeriodo: "0",
                precioTPTipo: "0",
                serviciosNoObligatorios: "",
                serviciosObligatorios: false,
                tarifaATR: "",
                verde: true,
                webContrato: "",
                webOferta: "",
                fechaAltaProducto: '',
                fechaBajaProducto: '',
                tipoProducto: '',
                precioTE1: "0",
                precioTE2: "0",
                precioTFijo: "0",
                factork:"0",
                comisionContratoNuevo:"0",
                comisionContratoRenovacion:"0",
                comisionConsumoAgente1:"0",
                comisionConsumoAgente2:"0",
                comisionConsumoAdmin:"0",
                comisionGOAgente1: "0",
                comisionGOAgente2:"0"
            },
            toggledClearRows: !this.state.toggledClearRows,
            saveProductoButtonDisabled: true,
            updateProductoButtonDisabled: true,
            fechaAltaProducto: '',
            fechaBajaProducto: '',
            inputDisabledP3456: false,
            inputDisabledE456: false
        });

        this.formRef.current.reset();

    };


    buscarProducto = async () => {

        console.log('VALOR DE this.state.companyIdUser', this.state)

        var idComercializadoraAux = ''
        if (this.state.filters.codeComercializadora != '0' && this.state.filters.codeComercializadora != ''){
                idComercializadoraAux = this.state.filters.codeComercializadora
                }

        var dataFilters = {
            'companyId': this.state.companyIdUser,
            'idComercializadora': idComercializadoraAux,
            'id': this.state.filters.idSearch,
            'nombreOferta': this.state.filters.nombreProductoSearch,
            'tipoContrato': this.state.filters.tipoContratoSearch,
            'esActiva': this.state.filters.tipoEstadoSearch,
            'periodoValidezDesde': this.state.filters.productoDesde,
            'periodoValidezHasta': this.state.filters.productoHasta
        };

        const valores = JSON.stringify(dataFilters)
        const headers = {
            'Authorization': 'Bearer my-token',
            'My-Custom-Header': 'foobar',
            'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
        };
        let direccionFile = "https://datapi.psgestion.es/producto/listado?id=" + this.state.companyIdUser;

        axios.get(direccionFile, { headers, params: { valores } }).
            then(result => {
                console.log('resultado del listados')
                if(result.data.rows.length>0){
                let data = result.data.rows

                this.setState({ productoDetailTotal: data });

                } else {
                this.warningAlertNIF()
                };
            }).catch((error) => {
                console.log('Failure')
                this.warningAlert();
            });

    };





    showTable = () => {
        if (this.state.show === false) {
            this.setState({
                show: true
            });

            const reftp = document.getElementById("tablaLecturas")
            console.log('VALORES DE REFTP', reftp)
            reftp ?.scrollIntoView({ behavior: "smooth" })

} else {

            this.setState({
                show: false
            });
        }
    }




    updateHandler(props) {

        if (this.state.updateDataProducto && (this.state.formProducto.nombreOferta && this.state.formProducto.nombreComercializadora)) {

            this.confirmAlertUpdate()

        } else {

            this.warningAlertFiltros()
        }

    };




    saveHandler(props) {

        if (this.state.saveDataProducto && (this.state.formProducto.nombreOferta && this.state.formProducto.nombreComercializadora)) {

            this.onSave()

        } else {

            notifyErrorRep();
        }

    };



    onUpdate = async () => {
        console.log('ESTAMOS EN ONSAVE VALORE DE THIS.STATE-------->', this.state.updateDataProducto)

        //const fechaActivacion = this.state.fechaActivacion;
        const companyId = this.state.companyIdUser.toString();
        const userId = this.state.userId.toString();

        if (this.state.updateDataProducto == true) {

            console.log('ENTRA EN SAVE DATOS producto')
            console.log('DATOS DE THIS.STATE   --------> ', this.state)

            var fechaAltaProducto = this.state.formProducto.fechaAltaProducto;
            if (!fechaAltaProducto) {
                fechaAltaProducto = moment().format("YYYY-MM-DDTHH:mm:ss");
            };

            var fechaBajaProducto = this.state.formProducto.fechaBajaProducto;

            if (!fechaBajaProducto) {

                fechaBajaProducto = ''
            }

            var productoDataUpdate = {}

            if (this.state.formProducto.tipoProducto == 'L') {

                let peaje = '3'
                if( this.state.formProducto.tarifaATR == '018'){
                    peaje = '3'
                    }  else if (this.state.formProducto.tarifaATR == '019'){
                        peaje = '4'
                    } else if (this.state.formProducto.tarifaATR != '019' && this.state.formProducto.tarifaATR != '018' ){
                            peaje ='6'
                        };

                productoDataUpdate = {
                    'TarifaDesc': this.state.formProducto.TarifaDesc?this.state.formProducto.TarifaDesc.toUpperCase():'',
                    'atencionCliente': this.state.formProducto.atencionCliente?this.state.formProducto.atencionCliente.toUpperCase():'',
                    'caracteristicas': this.state.formProducto.caracteristicas?this.state.formProducto.caracteristicas.toUpperCase():'',
                    'coIncluido': this.state.formProducto.coIncluido,
                    'companyId': this.state.companyIdUser,
                    'componentesRegulados': this.state.formProducto.componentesRegulados,
                    'condicionesPenalizacion': this.state.formProducto.condicionesPenalizacion?this.state.formProducto.condicionesPenalizacion.toUpperCase():'',
                    'condicionesRevisionPrecios': this.state.formProducto.condicionesRevisionPrecios?this.state.formProducto.condicionesRevisionPrecios.toUpperCase():'',
                    'consumoMaximoElectricidad' :parseFloat(this.state.formProducto.consumoMaximoElectricidad),
                    'consumoMinimoElectricidad': parseFloat(this.state.formProducto.consumoMinimoElectricidad),
                    'descuentoTE': parseFloat(this.state.formProducto.descuentoTE),
                    'descuentoTP': parseFloat(this.state.formProducto.descuentoTP),
                    'esActiva': this.state.formProducto.esActiva,
                    'facturacion': this.state.formProducto.facturacion,
                    'id': this.state.formProducto.id,
                    'idComercializadora': this.state.formProducto.idComercializadora,
                    'infoAdicional': this.state.formProducto.infoAdicional?this.state.formProducto.infoAdicional.toUpperCase():'',
                    'limitaciones': this.state.formProducto.limitaciones?this.state.formProducto.limitaciones.toUpperCase():'',
                    'nombreComercializadora': this.state.formProducto.nombreComercializadora.toUpperCase(),
                    'nombreOferta': this.state.formProducto.nombreOferta.toUpperCase(),
                    'nombreDocumentoContrato': this.state.formProducto.nombreDocumentoContrato?this.state.formProducto.nombreDocumentoContrato.toUpperCase():'',
                    'ofertaInternet': this.state.formProducto.ofertaInternet,
                    'ofertaOficina': this.state.formProducto.ofertaOficina,
                    'ofertaTel': this.state.formProducto.ofertaTel,
                    'peaje': peaje,
                    'penalizacionMaxElec': this.state.formProducto.penalizacionMaxElec,
                    'penalizacionMaxGas': this.state.formProducto.penalizacionMaxGas,
                    'periocidadRevisionPrecios': this.state.formProducto.periocidadRevisionPrecios,
                    'periodoValidez': this.state.formProducto.periodoValidez,
                    'periodoValidezDesde': this.state.formProducto.periodoValidezDesde,
                    'periodoValidezHasta': this.state.formProducto.periodoValidezHasta,
                    'potenciaMaximaElectricidad':  parseFloat(this.state.formProducto.potenciaMaximaElectricidad),
                    'potenciaMinimaElectricidad':  parseFloat(this.state.formProducto.potenciaMinimaElectricidad),
                    'precioAlquilerContadore':  parseFloat(this.state.formProducto.precioAlquilerContadore),
                    'precioServicios':  parseFloat(this.state.formProducto.precioServicios),
                    'precioTEP1': parseFloat(this.state.formProducto.precioTEP1),
                    'precioTEP2': parseFloat(this.state.formProducto.precioTEP2),
                    'precioTEP3': parseFloat(this.state.formProducto.precioTEP3),
                    'precioTEP4': parseFloat(this.state.formProducto.precioTEP4),
                    'precioTEP5': parseFloat(this.state.formProducto.precioTEP5),
                    'precioTEP6': parseFloat(this.state.formProducto.precioTEP6),
                    'precioTP1': parseFloat(this.state.formProducto.precioTP1),
                    'precioTP2': parseFloat(this.state.formProducto.precioTP2),
                    'precioTP3': parseFloat(this.state.formProducto.precioTP3),
                    'precioTP4': parseFloat(this.state.formProducto.precioTP4),
                    'precioTP5': parseFloat(this.state.formProducto.precioTP5),
                    'precioTP6': parseFloat(this.state.formProducto.precioTP6),
                    'precioTPPeriodo': parseFloat(this.state.formProducto.precioTPPeriodo),
                    'precioTPTipo': parseFloat(this.state.formProducto.precioTPTipo),
                    'serviciosObligatorios': this.state.formProducto.serviciosObligatorios,
                    'tarifaATR': this.state.formProducto.tarifaATR,
                    'verde': this.state.formProducto.verde,
                    'webContrato': this.state.formProducto.webContrato,
                    'webOferta': this.state.formProducto.webOferta,
                    'fechaAltaProducto': fechaAltaProducto,
                    'fechaBajaProducto': fechaBajaProducto,
                    'tipoProducto': this.state.formProducto.tipoProducto,
                    'comisionContratoNuevo':parseFloat(this.state.formProducto.comisionContratoNuevo),
                    'comisionContratoRenovacion':parseFloat(this.state.formProducto.comisionContratoRenovacion),
                    'comisionConsumoAgente1':parseFloat(this.state.formProducto.comisionConsumoAgente1),
                    'comisionConsumoAgente2':parseFloat(this.state.formProducto.comisionConsumoAgente2),
                    'comisionConsumoAdmin':parseFloat(this.state.formProducto.comisionConsumoAdmin),
                    'comisionGOAgente1': parseFloat(this.state.formProducto.comisionGOAgente1),
                    'comisionGOAgente2':parseFloat(this.state.formProducto.comisionGOAgente2)
                };
            } else if (this.state.formProducto.tipoProducto == 'G') {

                let peaje = '1'
                if( this.state.formProducto.tarifaATR == '018'){
                    peaje = '3'
                    }  else if (this.state.formProducto.tarifaATR == '019'){
                        peaje = '4'
                    } else if (this.state.formProducto.tarifaATR != '019' && this.state.formProducto.tarifaATR != '018' ){
                            peaje ='1'
                        };

console.log('VALORES DE THIS STATE EN PRODUCT UPDATE ----> ', this.state)

                productoDataUpdate = {
                    'TarifaDesc': this.state.formProducto.TarifaDesc?this.state.formProducto.TarifaDesc.toUpperCase():'',
                    'atencionCliente': this.state.formProducto.atencionCliente?this.state.formProducto.atencionCliente.toUpperCase():'',
                    'caracteristicas': this.state.formProducto.caracteristicas?this.state.formProducto.caracteristicas.toUpperCase():'',
                    'coIncluido': this.state.formProducto.coIncluido,
                    'companyId': this.state.companyIdUser,
                    'componentesRegulados': this.state.formProducto.componentesRegulados,
                    'condicionesPenalizacion': this.state.formProducto.condicionesPenalizacion?this.state.formProducto.condicionesPenalizacion.toUpperCase():'',
                    'condicionesRevisionPrecios': this.state.formProducto.condicionesRevisionPrecios?this.state.formProducto.condicionesRevisionPrecios.toUpperCase():'',
                    'consumoMaximoGas': parseFloat(this.state.formProducto.consumoMaximoGas),
                    'consumoMinimoGas': parseFloat(this.state.formProducto.consumoMinimoGas),
                    'descuentoTE': parseFloat(this.state.formProducto.descuentoTE),
                    'descuentoTP': parseFloat(this.state.formProducto.descuentoTP),
                    'esActiva': this.state.formProducto.esActiva,
                    'facturacion': this.state.formProducto.facturacion,
                    'id': this.state.formProducto.id,
                    'idComercializadora': this.state.formProducto.idComercializadora,
                    'infoAdicional': this.state.formProducto.infoAdicional?this.state.formProducto.infoAdicional.toUpperCase():'',
                    'limitaciones': this.state.formProducto.limitaciones?this.state.formProducto.limitaciones.toUpperCase():'',
                    'nombreComercializadora': this.state.formProducto.nombreComercializadora.toUpperCase(),
                    'nombreOferta': this.state.formProducto.nombreOferta.toUpperCase(),
                    'nombreDocumentoContrato': this.state.formProducto.nombreDocumentoContrato.toUpperCase(),
                    'ofertaInternet': this.state.formProducto.ofertaInternet,
                    'ofertaOficina': this.state.formProducto.ofertaOficina,
                    'ofertaTel': this.state.formProducto.ofertaTel,
                    'peaje': peaje,
                    'penalizacionMaxGas': this.state.formProducto.penalizacionMaxGas,
                    'periocidadRevisionPrecios': this.state.formProducto.periocidadRevisionPrecios,
                    'periodoValidez': this.state.formProducto.periodoValidez,
                    'periodoValidezDesde': this.state.formProducto.periodoValidezDesde,
                    'periodoValidezHasta': this.state.formProducto.periodoValidezHasta,
                    'precioAlquilerContadore':  parseFloat(this.state.formProducto.precioAlquilerContadore),
                    'precioServicios':  parseFloat(this.state.formProducto.precioServicios),
                    'precioTPPeriodo': parseFloat(this.state.formProducto.precioTPPeriodo),
                    'precioTPTipo': parseFloat(this.state.formProducto.precioTPTipo),
                    'serviciosObligatorios': this.state.formProducto.serviciosObligatorios,
                    'tarifaATR': this.state.formProducto.tarifaATR,
                    'verde': this.state.formProducto.verde,
                    'webContrato': this.state.formProducto.webContrato,
                    'webOferta': this.state.formProducto.webOferta,
                    'fechaAltaProducto': fechaAltaProducto,
                    'fechaBajaProducto': fechaBajaProducto,
                    'tipoProducto': this.state.formProducto.tipoProducto,
                    'precioTE1':parseFloat(this.state.formProducto.precioTE1),
                    'precioTE2':parseFloat(this.state.formProducto.precioTE2),
                    'precioTFijo':parseFloat(this.state.formProducto.precioTFijo),
                    'factork':parseFloat(this.state.formProducto.factork),
                    'comisionContratoNuevo':parseFloat(this.state.formProducto.comisionContratoNuevo),
                    'comisionContratoRenovacion':parseFloat(this.state.formProducto.comisionContratoRenovacion),
                    'comisionConsumoAgente1':parseFloat(this.state.formProducto.comisionConsumoAgente1),
                    'comisionConsumoAgente2':parseFloat(this.state.formProducto.comisionConsumoAgente2),
                    'comisionConsumoAdmin':parseFloat(this.state.formProducto.comisionConsumoAdmin),
                    'comisionGOAgente1': parseFloat(this.state.formProducto.comisionGOAgente1),
                    'comisionGOAgente2':parseFloat(this.state.formProducto.comisionGOAgente2)
                };


            }

            //const fechaActivacion = this.state.fechaActivacion;
            const companyId = this.state.companyIdUser.toString();
            const userId = this.state.userId.toString();
            const idContrato = this.state.contrato;
            var resultadoUpdate: any = [];
            var resultadoView: any = [];



            const headers = {
                'Authorization': 'Bearer my-token',
                'My-Custom-Header': 'foobar',
                'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
            };
            let direccionFile = "https://datapi.psgestion.es/producto/update?id=" + this.state.companyIdUser + "&user=" + userId;


            axios.post(direccionFile, productoDataUpdate, { headers, responseType: 'blob' })
                .then(res => {
                    console.log('Actualización correcta', res)
                    console.log('Dapos del registro: ', res.data)
                    this.successAlert();
                    this.clearForm();
                }).catch(error => {
                    console.log('Failure')
                    console.log('Error en el proceso: ', error)
                    this.warningAlert();
                });

                this.setState({
                            updateDataProducto: false,
                            updateProductoButtonDisabled: true
                        });

            await this.buscarProducto()


        }

    };


    onSave = async () => {
    };


    handleChangeDate = (value, formattedValue, id) => {

        console.log('VALORES DE FECHA DE ALATA')
        console.log(value)
        console.log(formattedValue)
        console.log(id)

        var formData = { ...this.state.formProducto };


        const name = id;
        var valueDay = formattedValue




        if (name == 'productoDesde') {
            //console.log('VALOR NOMBRE REPRESENTANTE ------> ', value, event.target.name)
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ productoDesde: value });

        }

        if (name == 'productoHasta') {
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ productoHasta: value });
        }


        if (name == 'fechaAltaProducto') {
            //console.log('VALOR NOMBRE REPRESENTANTE ------> ', value, event.target.name)
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ fechaAltaProducto: value });

        }

        if (name == 'fechaBajaProducto') {
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ fechaBajaProducto: value });
        }

        if (name == 'periodoValidezDesde') {
            //console.log('VALOR NOMBRE REPRESENTANTE ------> ', value, event.target.name)
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ periodoValidezDesde: value });

        }

        if (name == 'periodoValidezHasta') {
            //this.setState ({productoDetail.nombreOferta : event.target.value});
            this.setState({ periodoValidezHasta: value });
        }


        console.log(formData)
        formData[name] = valueDay;
        //if (value === "" || value === null) {
        //    formData[name] = 0;
        //}
        this.setState({ formProducto: formData });
    }

    handleChange = state => {
        // eslint-disable-next-line no-console
        //console.log('state', state.selectedRows[0]);
        //console.log(state.selectedCount)

        var producto = '';

        if (state.selectedCount === 1) {
            var existeProducto = ''
            producto = state.selectedRows[0].id;
            console.log(producto)
            this.setState({ productoDetail: state.selectedRows[0] });
            const hora = 6;
            const minutos = 30;

            var existeFechaAlta = state.selectedRows[0].fechaAltaProducto
            var FechaAltaAux = ''
            var existeFechaBaja = state.selectedRows[0].fechaBajaProducto
            var FechaBajaAux = ''

            //if (state.selectedRows[0].fechaAltaProducto) {
            //    console.log('ENTRA EN IF 1')
            //    existeFechaAlta = moment(new Date(state.selectedRows[0].fechaAltaProducto.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))).set("hour", hora).set("minute", minutos);
            //    FechaAltaAux = moment(existeFechaAlta).toISOString()
            //}

            //let existeFechaAlta = state.selectedRows[0].fechaAltaProducto
            //let existeFechaBaja = state.selectedRows[0].fechaBajaProducto
            existeProducto = state.selectedRows[0].id

            this.setState({
                fechaAltaProducto: state.selectedRows[0].fechaAltaProducto
            });

            console.log('fecha Alta ---- > ', existeFechaAlta)
                        console.log('fecha BAJA ---- > ', existeFechaBaja)
            console.log('THIS STATE EN HANDLECHANGE ----> ', this.state)

            if (existeFechaAlta && existeFechaBaja) {
                console.log('ENTRA EN EXISTE FECHA DE ALTA Y BAJA')

                this.setState({
                    inputDisabled: true,
                    updateProductoButtonDisabled: false
                })
            } else if ((!existeFechaAlta && !existeFechaBaja) || (existeFechaAlta && !existeFechaBaja)  ) {
                console.log('ENTRA EN no EXISTE FECHA DE ALTA Y BAJA')
                this.setState({
                    inputDisabled: false,
                    updateProductoButtonDisabled: true
                })
            }



            if (existeProducto) {
                console.log('VALORE DE productoDetail  ------> ', this.state.productoDetail)
                this.setState({ idProducto: this.state.productoDetail.id });
                this.setState({
                    formProducto: {
                        TarifaDesc: state.selectedRows[0].TarifaDesc,
                        atencionCliente: state.selectedRows[0].atencionCliente,
                        caracteristicas: state.selectedRows[0].caracteristicas,
                        coIncluido: state.selectedRows[0].coIncluido,
                        companyId: state.selectedRows[0].companyId,
                        componentesRegulados: state.selectedRows[0].componentesRegulados,
                        condicionesPenalizacion: state.selectedRows[0].condicionesPenalizacion,
                        condicionesRevisionPrecios: state.selectedRows[0].condicionesRevisionPrecios,
                        consumoMaximoElectricidad: state.selectedRows[0].consumoMaximoElectricidad,
                        consumoMaximoGas: state.selectedRows[0].consumoMaximoGas,
                        consumoMinimoElectricidad: state.selectedRows[0].consumoMinimoElectricidad,
                        consumoMinimoGas: state.selectedRows[0].consumoMinimoGas,
                        descuentoTE: state.selectedRows[0].descuentoTE,
                        descuentoTP: state.selectedRows[0].descuentoTP,
                        esActiva: state.selectedRows[0].esActiva,
                        facturacion: state.selectedRows[0].facturacion,
                        id: state.selectedRows[0].id,
                        idComercializadora: state.selectedRows[0].idComercializadora,
                        infoAdicional: state.selectedRows[0].infoAdicional,
                        limitaciones: state.selectedRows[0].limitaciones,
                        nombreComercializadora: state.selectedRows[0].nombreComercializadora,
                        nombreOferta: state.selectedRows[0].nombreOferta,
                        nombreDocumentoContrato: state.selectedRows[0].nombreDocumentoContrato,
                        ofertaInternet: state.selectedRows[0].ofertaInternet,
                        ofertaOficina: state.selectedRows[0].ofertaOficina,
                        ofertaTel: state.selectedRows[0].ofertaTel,
                        peaje: state.selectedRows[0].peaje,
                        penalizacionMaxElec: state.selectedRows[0].penalizacionMaxElec,
                        penalizacionMaxGas: state.selectedRows[0].penalizacionMaxGas,
                        periocidadRevisionPrecios: state.selectedRows[0].periocidadRevisionPrecios,
                        periodoValidez: state.selectedRows[0].periodoValidez,
                        periodoValidezDesde: state.selectedRows[0].periodoValidezDesde,
                        periodoValidezHasta: state.selectedRows[0].periodoValidezHasta,
                        potenciaMaximaElectricidad: state.selectedRows[0].potenciaMaximaElectricidad,
                        potenciaMinimaElectricidad: state.selectedRows[0].potenciaMinimaElectricidad,
                        precioAlquilerContadore: state.selectedRows[0].precioAlquilerContadore,
                        precioServicios: state.selectedRows[0].precioServicios,
                        precioTEP1: state.selectedRows[0].precioTEP1,
                        precioTEP2: state.selectedRows[0].precioTEP2,
                        precioTEP3: state.selectedRows[0].precioTEP3,
                        precioTEP4: state.selectedRows[0].precioTEP4,
                        precioTEP5: state.selectedRows[0].precioTEP5,
                        precioTEP6: state.selectedRows[0].precioTEP6,
                        precioTP1: state.selectedRows[0].precioTP1,
                        precioTP2: state.selectedRows[0].precioTP2,
                        precioTP3: state.selectedRows[0].precioTP3,
                        precioTP4: state.selectedRows[0].precioTP4,
                        precioTP5: state.selectedRows[0].precioTP5,
                        precioTP6: state.selectedRows[0].precioTP6,
                        precioTPPeriodo: state.selectedRows[0].precioTPPeriodo,
                        precioTPTipo: state.selectedRows[0].precioTPTipo,
                        serviciosObligatorios: state.selectedRows[0].serviciosObligatorios,
                        tarifaATR: state.selectedRows[0].tarifaATR,
                        verde: state.selectedRows[0].verde,
                        webContrato: state.selectedRows[0].webContrato,
                        webOferta: state.selectedRows[0].webOferta,
                        fechaAltaProducto: state.selectedRows[0].fechaAltaProducto,
                        fechaBajaProducto: state.selectedRows[0].fechaBajaProducto,
                        tipoProducto: state.selectedRows[0].tipoProducto,
                        precioTE1: state.selectedRows[0].precioTE1,
                        precioTE2: state.selectedRows[0].precioTE2,
                        precioTFijo: state.selectedRows[0].precioTFijo,
                        factork:state.selectedRows[0].factork,
                        comisionContratoNuevo:state.selectedRows[0].comisionContratoNuevo?state.selectedRows[0].comisionContratoNuevo:"0",
                        comisionContratoRenovacion:state.selectedRows[0].comisionContratoRenovacion?state.selectedRows[0].comisionContratoRenovacion:"0",
                        comisionConsumoAgente1:state.selectedRows[0].comisionConsumoAgente1?state.selectedRows[0].comisionConsumoAgente1:"0",
                        comisionConsumoAgente2:state.selectedRows[0].comisionConsumoAgente2?state.selectedRows[0].comisionConsumoAgente2:"0",
                        comisionConsumoAdmin:state.selectedRows[0].comisionConsumoAdmin?state.selectedRows[0].comisionConsumoAdmin:"0",
                        comisionGOAgente1: state.selectedRows[0].comisionGOAgente1?state.selectedRows[0].comisionGOAgente1:"0",
                        comisionGOAgente2:state.selectedRows[0].comisionGOAgente2?state.selectedRows[0].comisionGOAgente2:"0"
                    },
                    productoSeleccionado: true
                });

            } else {
                console.log('ENTRA EN NO existeProducto')
                this.setState({
                    productoSeleccionado: false,
                    formProducto: {
                        TarifaDesc: "",
                        atencionCliente: "",
                        caracteristicas: "",
                        coIncluido: false,
                        companyId: 0,
                        componentesRegulados: false,
                        condicionesPenalizacion: "",
                        condicionesRevisionPrecios: "",
                        consumoMaximoElectricidad: "0",
                        consumoMaximoGas: "0",
                        consumoMinimoElectricidad: "0",
                        consumoMinimoGas: "0",
                        descuentoTE: "0",
                        descuentoTP: "0",
                        esActiva: false,
                        facturacion: "",
                        id: "",
                        idComercializadora: "",
                        infoAdicional: "",
                        limitaciones: "",
                        nombreComercializadora: "",
                        nombreOferta: "",
                        nombreDocumentoContrato:"",
                        ofertaInternet: false,
                        ofertaOficina: false,
                        ofertaTel: false,
                        peaje: "",
                        penalizacionMaxElec: "0",
                        penalizacionMaxGas: "0",
                        periocidadRevisionPrecios: "",
                        periodoValidez: "",
                        periodoValidezDesde: "",
                        periodoValidezHasta: "",
                        potenciaMaximaElectricidad: "0",
                        potenciaMinimaElectricidad: "0",
                        precioAlquilerContadore: "0",
                        precioServicios: "0",
                        precioTEP1: "0",
                        precioTEP2: "0",
                        precioTEP3: "0",
                        precioTEP4: "0",
                        precioTEP5: "0",
                        precioTEP6: "0",
                        precioTP1: "0",
                        precioTP2: "0",
                        precioTP3: "0",
                        precioTP4: "0",
                        precioTP5: "0",
                        precioTP6: "0",
                        precioTPPeriodo: "0",
                        precioTPTipo: "0",
                        serviciosNoObligatorios: "",
                        serviciosObligatorios: false,
                        tarifaATR: "",
                        verde: true,
                        webContrato: "",
                        webOferta: "",
                        fechaAltaProducto: '',
                        fechaBajaProducto: '',
                        tipoProducto: '',
                        precioTE1: "0",
                        precioTE2: "0",
                        precioTFijo: "0",
                        factork:"0",
                        comisionContratoNuevo:"0",
        comisionContratoRenovacion:"0",
        comisionConsumoAgente1:"0",
        comisionConsumoAgente2:"0",
        comisionConsumoAdmin:"0",
        comisionGOAgente1: "0",
        comisionGOAgente2:"0"
                    }
                });
            }
        } else {

            this.setState({
                productoSeleccionado: false,
                inputDisabled: false,
                updateProductoButtonDisabled: true,
                formProducto: {
                    TarifaDesc: "",
                    atencionCliente: "",
                    caracteristicas: "",
                    coIncluido: false,
                    companyId: 0,
                    componentesRegulados: false,
                    condicionesPenalizacion: "",
                    condicionesRevisionPrecios: "",
                    consumoMaximoElectricidad: "0",
                    consumoMaximoGas: "0",
                    consumoMinimoElectricidad: "0",
                    consumoMinimoGas: "0",
                    descuentoTE: "0",
                    descuentoTP: "0",
                    esActiva: false,
                    facturacion: "",
                    id: "",
                    idComercializadora: "",
                    infoAdicional: "",
                    limitaciones: "",
                    nombreComercializadora: "",
                    nombreOferta: "",
                    nombreDocumentoContrato:"",
                    ofertaInternet: false,
                    ofertaOficina: false,
                    ofertaTel: false,
                    peaje: "",
                    penalizacionMaxElec: "0",
                    penalizacionMaxGas: "0",
                    periocidadRevisionPrecios: "",
                    periodoValidez: "",
                    periodoValidezDesde: "",
                    periodoValidezHasta: "",
                    potenciaMaximaElectricidad: "0",
                    potenciaMinimaElectricidad: "0",
                    precioAlquilerContadore: "0",
                    precioServicios: "0",
                    precioTEP1: "0",
                    precioTEP2: "0",
                    precioTEP3: "0",
                    precioTEP4: "0",
                    precioTEP5: "0",
                    precioTEP6: "0",
                    precioTP1: "0",
                    precioTP2: "0",
                    precioTP3: "0",
                    precioTP4: "0",
                    precioTP5: "0",
                    precioTP6: "0",
                    precioTPPeriodo: "0",
                    precioTPTipo: "0",
                    serviciosNoObligatorios: "",
                    serviciosObligatorios: false,
                    tarifaATR: "",
                    verde: true,
                    webContrato: "",
                    webOferta: "",
                    fechaAltaProducto: '',
                    fechaBajaProducto: '',
                    tipoProducto: '',
                    precioTE1: "0",
                    precioTE2: "0",
                    precioTFijo: "0",
                    factork:"0",
                    comisionContratoNuevo:"0",
    comisionContratoRenovacion:"0",
    comisionConsumoAgente1:"0",
    comisionConsumoAgente2:"0",
    comisionConsumoAdmin:"0",
    comisionGOAgente1: "0",
    comisionGOAgente2:"0"

                }
            });



        };

        if (state.selectedRows[0].tipoProducto == 'L' && state.selectedRows[0].tarifaATR == '018') {

        console.log('VALORES DE STATE EN IF L y 018---->', state.selectedRows[0].tipoProducto, state.selectedRows[0].tarifaATR )


            this.setState({
                inputDisabledP3456: true,
                inputDisabledE456: true

            })
        } else if (state.selectedRows[0].tipoProducto == 'L' && state.selectedRows[0].tarifaATR != '018') {

                console.log('VALORES DE STATE EN IF L y 019---->', state.selectedRows[0].tipoProducto, state.selectedRows[0].tarifaATR )
            this.setState({
                inputDisabledP3456: false,
                inputDisabledE456: false

            })
        }

    };



    handleClearRows = () => {
        this.setState({ toggledClearRows: !this.state.toggledClearRows })
    }

    tipoContrato = (props) => {
        const tipoContrato = props.tipoContrato;
        console.log('VALOR DE tipoContrato  -------------->', tipoContrato)
        if (this.state.esAgencia == true || this.state.esAdFincas == true) {
            if (tipoContrato === 'L') {
                return (
                    <React.Fragment>
                        <Col md="12" lg="4">
                            <FormGroup>
                                <Label
                                    className="form-control-label"
                                    htmlFor="codigoComercializadora"
                                >
                                    Comercializadora
                          </Label>
                                <SipsOption
                                    placeholder="Seleccionar comercializadora"
                                    id="codeComercializadora"
                                    name="codeComercializadora"
                                    value={this.state.filters.codeComercializadora}
                                    query="LIST_MARKETERS"
                                    onChange={this.onChangeFieldSearch}
                                />
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                )

            } else {
                return (
                    <React.Fragment>
                        <Col md="12" lg="4">
                            <FormGroup>
                                <Label
                                    className="form-control-label"
                                    htmlFor="codigoComercializadora"
                                >
                                    Comercializadora
            </Label>
                                <SipsOption
                                    placeholder="Seleccionar comercializadora"
                                    id="codeComercializadora"
                                    name="codeComercializadora"
                                    value={this.state.filters.codeComercializadora}
                                    query="LIST_MARKETERS_GAS"
                                    onChange={this.onChangeFieldSearch}
                                />
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                )

            }
        } else {
            return (
                <React.Fragment>

                </React.Fragment>
            )
        }
    };

/////////////////////////////////////////////////////////////////////////////////

    tipoLecturaTable = (props) => {
        const tipoContrato = props.tipoContrato;

        if (tipoContrato === 'G') {
            return (

                <React.Fragment>

                    <Card className="shadow">
                        <DataTable
                            title="LISTADO DE PRODUCTOS GAS"
                            columns={columnsDatosProductosGas}
                            data={this.state.productoDetailTotal}
                            selectableRows
                            //selectableRowsComponent={radio} // Pass the function only
                            selectableRowsComponentProps={{ type: 'radio' }}// optionally, pass Material Ui supported props down to our custom checkbox
                            selectableRowsSingle
                            sortIcon={sortIcon} // use a material icon for our sort icon. rdt will rotate the icon 180 degrees for you           fixedHeader = {true}
                            noDataComponent={"Sin datos para mostrar"}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 40]}
                            onSelectedRowsChange={this.handleChange}
                            clearSelectedRows={this.state.toggledClearRows}
                            highlightOnHover
                            striped
                            pointerOnHover
                            selectableRowsHighlight
                            customStyles={customStyles}
                            contextMessage={{ singular: 'producto', plural: 'productos', message: 'seleccionado' }}
                            subHeader
                            subHeaderComponent={
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <CSVLink
                                        data={this.state.productoDetailTotal}
                                        filename={"ListadoProductosGasDetalle.csv"}
                                        className="btn btn-default btn-sm btn-circle"
                                        color="default"
                                        target="_blank"
                                        separator={";"}
                                    >

                                        <span className="btn-inner--icon">
                                            <i className={"bi bi-file-earmark-spreadsheet"} style={{ fontSize: 25 }}></i>
                                        </span>
                                        <span className="btn-inner--text">Fichero CSV</span>

                                    </CSVLink>
                                </div>


                            }
                            progressComponent={<Circular />}
                        />
                    </Card>

                </React.Fragment>

            )

        } else {
            return (
                <React.Fragment>

                    <Card className="shadow">
                        <DataTable
                            title="LISTADO DE PRODUCTOS ELECTRICIDAD"
                            columns={columnsDatosProductosLuz}
                            data={this.state.productoDetailTotal}
                            selectableRows
                            //selectableRowsComponent={radio} // Pass the function only
                            selectableRowsComponentProps={{ type: 'radio' }}// optionally, pass Material Ui supported props down to our custom checkbox
                            selectableRowsSingle
                            sortIcon={sortIcon} // use a material icon for our sort icon. rdt will rotate the icon 180 degrees for you           fixedHeader = {true}
                            noDataComponent={"Sin datos para mostrar"}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 40]}
                            onSelectedRowsChange={this.handleChange}
                            clearSelectedRows={this.state.toggledClearRows}
                            highlightOnHover
                            striped
                            pointerOnHover
                            selectableRowsHighlight
                            customStyles={customStyles}
                            contextMessage={{ singular: 'producto', plural: 'productos', message: 'seleccionado' }}
                            subHeader
                            subHeaderComponent={
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <CSVLink
                                        data={this.state.productoDetailTotal}
                                        filename={"ListadoProductosElectricidadDetalle.csv"}
                                        className="btn btn-default btn-sm btn-circle"
                                        color="default"
                                        target="_blank"
                                        separator={";"}
                                    >

                                        <span className="btn-inner--icon">
                                            <i className={"bi bi-file-earmark-spreadsheet"} style={{ fontSize: 25 }}></i>
                                        </span>
                                        <span className="btn-inner--text">Fichero CSV</span>

                                    </CSVLink>
                                </div>

                            }
                            progressComponent={<Circular />}
                        />
                    </Card>

                </React.Fragment>

            )

        }
    };

/////////////////////////////////////////////////////////////////////////////////


//<this.comision tipoComision={formProducto.coIncluido} />
comision = (props) => {
        const tipoComision = props.tipoComision;

        if (tipoComision === true) {
    return (

    <React.Fragment>

<Col md="2" sm="2" lg="2">
    <FormGroup>
        <Label
            className="form-control-label"
            htmlFor="comisionConsumoAgente1"
        >
            CONSUMO AGENTE 1 AÑO
        </Label>
        <Input
            className="text-primary"
            id="comisionConsumoAgente1"
            placeholder="0"
            name="comisionConsumoAgente1"
            min={0}
            onChange={this.onChangeFieldProducto}
            value={this.state.formProducto.comisionConsumoAgente1}
            type="number"
            required
        />

        <FormText color="muted">
            Introduzca el porcentaje sobre consumos Anual
    </FormText>
    </FormGroup>
</Col>

<Col md="2" sm="2" lg="2">
    <FormGroup>
        <Label
            className="form-control-label"
            htmlFor="comisionConsumoAgente2"
        >
            CONSUMO AGENTE 2 AÑO
        </Label>
        <Input
            className="text-primary"
            id="comisionConsumoAgente2"
            placeholder="0"
            name="comisionConsumoAgente2"
            min={0}
            onChange={this.onChangeFieldProducto}
            value={this.state.formProducto.comisionConsumoAgente2}
            type="number"
            required
        />

        <FormText color="muted">
            Introduzca el porcentaje sobre consumos Anual
    </FormText>
    </FormGroup>
</Col>

<Col md="2" sm="2" lg="2">
    <FormGroup>
        <Label
            className="form-control-label"
            htmlFor="comisionConsumoAdmin"
        >
            COMISION CONSUMO ADMIN
        </Label>
        <Input
            className="text-primary"
            id="comisionConsumoAdmin"
            placeholder="0"
            name="comisionConsumoAdmin"
            min={0}
            onChange={this.onChangeFieldProducto}
            value={this.state.formProducto.comisionConsumoAdmin}
            type="number"
            required
        />

        <FormText color="muted">
            Introduzca el porcentaje sobre consumos Anual
    </FormText>
    </FormGroup>
</Col>
</React.Fragment>

)

} else  {
return(
<React.Fragment>

    <Col md="2" sm="2" lg="2">
        <FormGroup>
            <Label
                className="form-control-label"
                htmlFor="comisionGOAgente1"
            >
                PORCENTAJE GO NIVEL 1
            </Label>
            <Input
                className="text-primary"
                id="comisionGOAgente1"
                placeholder="0"
                name="comisionGOAgente1"
                min={0}
                onChange={this.onChangeFieldProducto}
                value={this.state.formProducto.comisionGOAgente1}
                type="number"
                required
            />

            <FormText color="muted">
                Introduzca el porcentaje sobre consumos Anual
        </FormText>
        </FormGroup>
    </Col>

    <Col md="2" sm="2" lg="2">
        <FormGroup>
            <Label
                className="form-control-label"
                htmlFor="comisionGOAgente2"
            >
                PORCENTAJE GO NIVEL 2
            </Label>
            <Input
                className="text-primary"
                id="comisionGOAgente2"
                placeholder="0"
                name="comisionGOAgente2"
                min={0}
                onChange={this.onChangeFieldProducto}
                value={this.state.formProducto.comisionGOAgente2}
                type="number"
                required
            />

            <FormText color="muted">
                Introduzca el porcentaje sobre consumos Anual
        </FormText>
        </FormGroup>
    </Col>

    </React.Fragment>

)

}
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////











//////////////////////////////////////////////////////////////////////////////////////
    tipoLecturaSelect = (props) => {
        const tipoContrato = props.tipoContrato;

        if (tipoContrato === 'G') {
            return (

                <React.Fragment>
                    <Col md="12" lg="4">
                        <FormGroup>
                            <Label
                                className="form-control-label"
                                htmlFor="idComercializadora"
                            >
                                Comercializadora
                                                </Label>
                            <SipsOption
                                placeholder="Seleccionar comercializadora"
                                id="idComercializadora"
                                name="idComercializadora"
                                value={this.state.formProducto.idComercializadora}
                                query="LIST_MARKETERS_GAS"
                                onChange={this.onChangeFieldProducto}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>

                            <Label className="form-control-label" htmlFor="nombreComercializadora">
                                Comercializadora
                                                    </Label>
                            <Input
                                id="nombreComercializadora"
                                placeholder=""
                                name="nombreComercializadora"
                                onChange={this.onChangeFieldProducto}
                                value={this.state.formProducto.nombreComercializadora}
                                type="text"
                                required
                                disabled={this.state.inputDisabled}
                            />
                        </FormGroup>
                    </Col>

                    <Col md="1" lg="1">
                        <FormGroup>
                            <Label
                                className="form-control-label"
                                htmlFor="tarifaATR"
                            >
                                Tarifas
                </Label>
                            <SipsGasOption
                                placeholder="Seleccionar tarifa"
                                id="tarifaATR"
                                name="tarifaATR"
                                value={this.state.formProducto.tarifaATR}
                                query="LIST_RATESGAS"
                                onChange={this.onChangeFieldProducto}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>

                            <Label className="form-control-label" htmlFor="TarifaDesc">
                                Tarifa Desc.
                </Label>
                            <Input
                                id="TarifaDesc"
                                placeholder=""
                                name="TarifaDesc"
                                onChange={this.onChangeFieldProducto}
                                value={this.state.formProducto.TarifaDesc}
                                type="text"
                                required
                                disabled={this.state.inputDisabled}
                            />
                        </FormGroup>
                    </Col>

                </React.Fragment>

            )

        } else {
            return (
                <React.Fragment>

                    <Col md="12" lg="4">
                        <FormGroup>
                            <Label className="form-control-label" htmlFor="idComercializadora">
                                Comercializadora
                </Label>
                            <SipsOption
                                placeholder="Seleccionar comercializadora"
                                id="idComercializadora"
                                name="idComercializadora"
                                value={this.state.formProducto.idComercializadora}
                                query="LIST_MARKETERS"
                                onChange={this.onChangeFieldProducto}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>

                            <Label className="form-control-label" htmlFor="nombreComercializadora">
                                Comercializadora
                </Label>
                            <Input
                                id="nombreComercializadora"
                                placeholder=""
                                name="nombreComercializadora"
                                onChange={this.onChangeFieldProducto}
                                value={this.state.formProducto.nombreComercializadora}
                                type="text"
                                required
                                disabled={this.state.inputDisabled}
                            />
                        </FormGroup>
                    </Col>

                    <Col md="1" lg="1">
                        <FormGroup>
                            <Label className="form-control-label" htmlFor="tarifaATR">
                                Tarifas
                </Label>
                            <SipsOption
                                placeholder="Seleccionar tarifa"
                                id="tarifaATR"
                                name="tarifaATR"
                                value={this.state.formProducto.tarifaATR}
                                query="LIST_RATES"
                                onChange={this.onChangeFieldProducto}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>

                            <Label className="form-control-label" htmlFor="TarifaDesc">
                                Tarifa Desc.
                </Label>
                            <Input
                                id="TarifaDesc"
                                placeholder=""
                                name="TarifaDesc"
                                onChange={this.onChangeFieldProducto}
                                value={this.state.formProducto.TarifaDesc}
                                type="text"
                                required
                                disabled={this.state.inputDisabled}
                            />
                        </FormGroup>
                    </Col>

                </React.Fragment>

            )

        }
    };

///////////////////////////////////////////////////////////////////////////////////////

    tipoContratoPeriodos = (props) => {
        const tipoContrato = props.tipoContrato;

        if (tipoContrato === 'G') {
            return (

                <React.Fragment>

                    <Row>

                        <Col md="2" lg="2">
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTE1">
                                    TERMINO VAR. ENERGIA P1
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTE1"
                                    placeholder=""
                                    name="precioTE1"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTE1}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>
                        <Col  md="2" lg="2">
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTE2">
                                    TERMINO VAR. ENERGIA P2
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTE2"
                                    placeholder=""
                                    name="precioTE2"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTE2}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2" lg="2">
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="factork">
                                    Factor K
                                                                                    </Label>
                                <Input
                                    className="text-primary"
                                    id="factork"
                                    placeholder=""
                                    name="factork"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.factork}
                                    type="number"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col  md="2" lg="2">
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTFijo">
                                    TERMINO FIJO ENERGIA
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTFijo"
                                    placeholder=""
                                    name="precioTFijo"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTFijo}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>

                    </Row>


                </React.Fragment>

            )

        } else {
            return (
                <React.Fragment>

                    <Row>

                        <Col>
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTEP1">
                                    TERMINO ENERGIA P1
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP1"
                                    placeholder=""
                                    name="precioTEP1"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP1}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTEP2">
                                    TERMINO ENERGIA P2
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP2"
                                    placeholder=""
                                    name="precioTEP2"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP2}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>


                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTEP3">
                                    TERMINO ENERGIA P3
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP3"
                                    placeholder=""
                                    name="precioTEP3"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP3}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />

                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTEP4">
                                    TERMINO ENERGIA P4
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP4"
                                    placeholder=""
                                    name="precioTEP4"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP4 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledE456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTEP5">
                                    TERMINO ENERGIA P5
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP5"
                                    placeholder=""
                                    name="precioTEP5"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP5 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledE456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTEP6">
                                    TERMINO ENERGIA P6
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTEP6"
                                    placeholder=""
                                    name="precioTEP6"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTEP6 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledE456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTP1">
                                    TERMINO POTENCIA P1
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP1"
                                    placeholder=""
                                    name="precioTP1"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP1}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>

                                <Label className="form-control-label" htmlFor="precioTP2">
                                    TERMINO POTENCIA P2
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP2"
                                    placeholder=""
                                    name="precioTP2"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP2}
                                    type="text"
                                    required
                                    disabled={this.state.inputDisabled}
                                />
                            </FormGroup>
                        </Col>


                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTP3">
                                    TERMINO POTENCIA P3
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP3"
                                    placeholder=""
                                    name="precioTP3"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP3 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledP3456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTP4">
                                    TERMINO POTENCIA P4
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP4"
                                    placeholder=""
                                    name="precioTP4"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP4 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledP3456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTP5">
                                    TERMINO POTENCIA P5
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP5"
                                    placeholder=""
                                    name="precioTP5"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP5 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledP3456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="precioTP6">
                                    TERMINO POTENCIA P6
                    </Label>
                                <Input
                                    className="text-primary"
                                    id="precioTP6"
                                    placeholder=""
                                    name="precioTP6"
                                    onChange={this.onChangeFieldProducto}
                                    value={this.state.formProducto.precioTP6 || ''}
                                    type="text"
                                    required
                                    hidden={this.state.inputDisabledP3456}
                                    disabled={this.state.inputIdDisabled}
                                />
                            </FormGroup>
                        </Col>

                    </Row>


                </React.Fragment>

            )

        }
    }





    render() {

        const formProducto: any = this.state.formProducto;
        console.log('VALOR DE THIS:STATE EN RENDER SIPDETAILSCONTRATOS ------> ', this.state)
        const fechaAltaProducto = this.state.fechaAltaProducto
        const fechaBajaProducto = this.state.fechaBajaProducto

        const productoDesde = this.state.productoDesde
        const productoHasta = this.state.productoHasta

        const periodoValidezHasta = this.state.periodoValidezHasta
        const periodoValidezDesde = this.state.periodoValidezDesde



        var textoTipoContrato = '';
        if (this.state.tipoContrato == 'G') {
            textoTipoContrato = 'Gas';
        } else {
            textoTipoContrato = 'Eléctrico';
        }

if(this.state.userGroupId == 1000) {
        return (
            <>
                <Header title={'Información Productos'} />
                <Container className=" mt--7" fluid>

                    <Card className="mb-4">
                        <CardHeader>
                            <Button
                                onClick={this.showFiltersToggle}
                                size="sm"
                                className="float-right"
                            >
                                <i className={"ni " + this.getFilterIcon()} />
                            </Button>
                            <h3 className="mb-0">Filtrar</h3>
                        </CardHeader>
                        <Collapse isOpen={this.state.showFilters}>
                            <CardBody>
                                <Form innerRef={this.formRef}>
                                    <Row>
                                        <Col md="12" lg="3">
                                            <FormGroup>
                                                <Label className="form-control-label" htmlFor="productoRef">
                                                    NOMBRE PRODUCTO
                                  </Label>
                                                <Input
                                                    id="nombreProductoSearch"
                                                    placeholder="Ingresar nombre del producto"
                                                    name="nombreProductoSearch"
                                                    maxLength={60}
                                                    onChange={this.onChangeFieldSearch}
                                                    value={this.state.filters.nombreProductoSearch}
                                                    type="text"
                                                    disabled={this.state.inputNombreProductoDisabled}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" htmlFor="idSearch">
                                                    Identificador
                                  </Label>
                                                <Input
                                                    id="idSearch"
                                                    placeholder="Ingresar ID del producto"
                                                    name="idSearch"
                                                    maxLength={40}
                                                    onChange={this.onChangeFieldSearch}
                                                    value={this.state.filters.idSearch}
                                                    type="text"
                                                    disabled={this.state.inputIdDisabled}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="tipoEnergia">TIPO CONTRATO</Label>
                                                <Input type="select" name="tipoContratoSearch" id="tipoContratoSearch"
                                                    onChange={this.onChangeFieldSearch}
                                                    value={this.state.filters.tipoContratoSearch}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="L">ELECTRICIDAD</option>
                                                    <option value="G">GAS</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <this.tipoContrato tipoContrato={this.state.filters.tipoContratoSearch} />

                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="tipoEstadoProducto">ESTADO</Label>
                                                <Input type="select" name="tipoEstadoSearch" id="tipoEstadoSearch"
                                                    onChange={this.onChangeFieldSearch}
                                                    value={this.state.filters.tipoEstadoSearch}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">ACTIVO</option>
                                                    <option value="false">BAJA</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2">
                                            <FormGroup>
                                                <Label className="form-control-label">Desde</Label>
                                                <DatePicker id="productoDesde"
                                                    value={productoDesde}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "productoDesde")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col md="2">
                                            <FormGroup>
                                                <Label className="form-control-label">Hasta</Label>
                                                <DatePicker id="productoHasta"
                                                    value={productoHasta}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "productoHasta")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}

                                                />
                                            </FormGroup>
                                        </Col>



                                        <Col className="text-right">
                                            <Button onClick={this.clearForm}>
                                                <i className={"ni ni-fat-remove"} /> Limpiar
                                    </Button>
                                            <Button
                                                color="primary"
                                                onClick={this.buscarProducto}
                                                disabled={this.state.buscarButtonDisabled}
                                            >
                                                <i className={"bi bi-search"}/> Buscar
                                    </Button>
                                        </Col>
                                    </Row>


                                    <this.tipoLecturaTable tipoContrato={this.state.filters.tipoContratoSearch} />


                                </Form>
                            </CardBody>
                        </Collapse>
                    </Card>




                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={this.props.history.goBack}
                                            >
                                                Atrás
                                            </button>
                                        </Col>

                                        <Col className="col-auto d-flex">
                                            <Card className="p-3 bg-light">
                                                <FormGroup>

                                                    <Button disabled={this.state.updateProductoButtonDisabled} id="UpdateRepreProptooltip" color="danger" size="m" type="button" className="btn-icon btn-sm btn-circle"
                                                        onClick={() => {this.updateHandler(this.state.updateDataProducto) }}
                                                    >
                                                        <span className="btn-inner--icon">
                                                            <i className="fas fa-save fa-2x" style={{ fontSize: 35 }}></i>
                                                        </span>
                                                        <span className="btn-inner--text"> Actualizar</span>
                                                        <UncontrolledTooltip delay={0} placement="top" target="UpdateRepreProptooltip">
                                                            GUARDAR DATOS DEL PRODUCTO ACTUAL
                                                                    </UncontrolledTooltip>
                                                    </Button>





                                                </FormGroup>


                                            </Card>
                                        </Col>


                                        <Card className="p-3 bg-light">
                                            <FormGroup>
                                                <Link
                                                    color="info" type="button" className="btn btn-warning btn-sm btn-circle"
                                                    data-toggle="modal"
                                                    to={{ pathname: "nuevo-producto/G" }}
                                                    id="newGasProduct"
                                                >
                                                    <span className="btn-inner--icon">
                                                        <i className="bi bi-file-earmark-post" style={{ fontSize: 25 }}></i>
                                                    </span>
                                                    <span className="btn-inner--text">Nuevo Prod. GAS</span>

                                                    <UncontrolledTooltip delay={0} placement="top" target="newGasProduct">
                                                        CREAR PRODUCTO NUEVO GAS
                                                 </UncontrolledTooltip>
                                                </Link>

                                                <Link
                                                    color="info" type="button" className="btn btn-primary btn-sm btn-circle"
                                                    data-toggle="modal"
                                                    to={{ pathname: "nuevo-producto/L" }}
                                                    id="newElecProduct"
                                                >
                                                    <span className="btn-inner--icon">
                                                        <i className="bi bi-file-earmark-post" style={{ fontSize: 25 }}></i>
                                                    </span>
                                                    <span className="btn-inner--text">Nuevo Prod. ELEC</span>

                                                    <UncontrolledTooltip delay={0} placement="top" target="newElecProduct">
                                                        CREAR PRODUCTO NUEVO ELECTRICIDAD
                                                </UncontrolledTooltip>
                                                </Link>
                                            </FormGroup>
                                        </Card>


                                    </Row>


                                    <div>
                                        <CardTitle>PRODUCTO</CardTitle>
                                    </div>

                                    <Row>
                                        <Col>
                                            <FormGroup>

                                                <Label className="form-control-label" htmlFor="nombreOferta">
                                                    Nombre Producto
                                                                                    </Label>
                                                <Input
                                                    className="text-primary"
                                                    id="nombreOferta"
                                                    placeholder=""
                                                    name="nombreOferta"
                                                    maxLength={80}
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.nombreOferta}
                                                    type="text"
                                                    required
                                                    disabled={this.state.inputDisabled}
                                                />
                                            </FormGroup>
                                        </Col>


                                        <this.tipoLecturaSelect tipoContrato={this.state.productoDetail.tipoProducto} />


                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="tipoesActiva">ACTIVA?</Label>
                                                <Input type="select" name="esActiva" id="esActiva"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.esActiva}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">ACTIVA</option>
                                                    <option value="false">BAJA</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>

                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="tipocoIncluido">CO INCLUIDO</Label>
                                                <Input type="select" name="coIncluido" id="coIncluido"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.coIncluido}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="tipoverde">VERDE</Label>
                                                <Input type="select" name="verde" id="verde"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.verde}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2">
                                            <FormGroup>

                                                <Label className="form-control-label" htmlFor="fechaAltaProducto">
                                                    Fecha Alta Registro
                                                </Label>

                                                <DatePicker id="fechaAltaProducto"
                                                    value={fechaAltaProducto}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "fechaAltaProducto")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}

                                                />

                                            </FormGroup>

                                        </Col>


                                        <Col md="2">
                                            <FormGroup>

                                                <Label className="form-control-label" htmlFor="fechaBajaProducto">
                                                    Fecha Baja Registro
                                                                                    </Label>

                                                <DatePicker id="fechaBajaProducto"
                                                    value={fechaBajaProducto}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "fechaBajaProducto")}
                                                    instanceCount={2}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}

                                                />


                                            </FormGroup>
                                        </Col>

                                    </Row>

                                </CardBody>
                            </Card>

                            <Card className="shadow">
                                <CardBody>
                                    <div>
                                        <CardTitle>TARIFAS</CardTitle>
                                    </div>
                                    <Row>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="precioTPTipo">Periodo Precio</Label>
                                                <Input type="select" name="precioTPTipo" id="precioTPTipo"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.precioTPTipo}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="DIARIO">DIARIO</option>
                                                    <option value="ANUAL">ANUAL</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="periocidadRevisionPrecios">Duración Contrato</Label>
                                                <Input type="select" name="periocidadRevisionPrecios" id="periocidadRevisionPrecios"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.periocidadRevisionPrecios}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="ANUAL">12 MESES</option>
                                                    <option value="BIANUAL">24 MESES</option>
                                                    <option value="TRIANUAL">36 MESES</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="2">
                                            <FormGroup>

                                                <Label className="form-control-label" htmlFor="periodoValidezDesde">
                                                    Oferta Válida Desde
                                                </Label>

                                                <DatePicker id="periodoValidezDesde"
                                                    value={periodoValidezDesde}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "periodoValidezDesde")}
                                                    instanceCount={1}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}

                                                />

                                            </FormGroup>

                                        </Col>


                                        <Col md="2">
                                            <FormGroup>

                                                <Label className="form-control-label" htmlFor="periodoValidezHasta">
                                                    Oferta Válida HAsta
                                                </Label>

                                                <DatePicker id="periodoValidezHasta"
                                                    value={periodoValidezHasta}
                                                    onChange={(v, f) => this.handleChangeDate(v, f, "periodoValidezHasta")}
                                                    instanceCount={2}
                                                    dateFormat={"DD-MM-YYYY"}
                                                    dayLabels={spanishDayLabels}
                                                    monthLabels={spanishMonthLabels}
                                                    disabled={this.state.inputDisabled}

                                                />


                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <this.tipoContratoPeriodos tipoContrato={this.state.productoDetail.tipoProducto} />


                                </CardBody>
                            </Card>

                            <Card className="shadow">

                                <CardBody>
                                    <div>
                                        <CardTitle>COMISIONES</CardTitle>
                                    </div>
                                <Row>

                                    <Col md="2" sm="2" lg="2">
                                        <FormGroup>
                                            <Label
                                                className="form-control-label"
                                                htmlFor="comisionContratoNuevo"
                                            >
                                                COMISION CONTRATO NUEVO
                                            </Label>
                                            <Input
                                                className="text-primary"
                                                id="comisionContratoNuevo"
                                                placeholder="0"
                                                name="comisionContratoNuevo"
                                                min={0}
                                                onChange={this.onChangeFieldProducto}
                                                value={formProducto.comisionContratoNuevo}
                                                type="number"
                                                required
                                            />

                                            <FormText color="muted">
                                                Introduzca la cantidad en euros
                                        </FormText>
                                        </FormGroup>
                                    </Col>

                                    <Col md="2" sm="2" lg="2">
                                        <FormGroup>
                                            <Label
                                                className="form-control-label"
                                                htmlFor="comisionContratoRenovacion"
                                            >
                                                COMISION CONTRATO RENOVACION
                                            </Label>
                                            <Input
                                                className="text-primary"
                                                id="comisionContratoRenovacion"
                                                placeholder="0"
                                                name="comisionContratoRenovacion"
                                                min={0}
                                                onChange={this.onChangeFieldProducto}
                                                value={formProducto.comisionContratoRenovacion}
                                                type="number"
                                                required
                                            />

                                            <FormText color="muted">
                                                Introduzca la cantidad en euros
                                        </FormText>
                                        </FormGroup>
                                    </Col>

<this.comision tipoComision={formProducto.coIncluido} />

                                </Row>

                                </CardBody>

                                <CardBody>
                                    <div>
                                        <CardTitle>OTROS DATOS</CardTitle>
                                    </div>

                                    <Row>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="ofertaInternet">OFERTA INTERNET</Label>
                                                <Input type="select" name="ofertaInternet" id="ofertaInternet"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.ofertaInternet}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="ofertaOficina">OFERTA OFICINA</Label>
                                                <Input type="select" name="ofertaOficina" id="ofertaOficina"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.ofertaOficina}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="ofertaTel">OFERTA TELEFONICA</Label>
                                                <Input type="select" name="ofertaTel" id="ofertaTel"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.ofertaTel}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <Label className="form-control-label" for="serviciosObligatorios">SERVICIOS OBLIGATORIOS</Label>
                                                <Input type="select" name="serviciosObligatorios" id="serviciosObligatorios"
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.serviciosObligatorios}>
                                                    <option selected>Selecciona...</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col md="3" sm="3" lg="3">
                                            <FormGroup>
                                                <Label
                                                    className="form-control-label"
                                                    htmlFor="nombreDocumentoContrato"
                                                >
                                                    NOMBRE DOCUMENTO CONTRATO
                                                </Label>
                                                <Input
                                                    className="text-primary"
                                                    id="nombreDocumentoContrato"
                                                    placeholder=""
                                                    name="nombreDocumentoContrato"
                                                    maxLength={80}
                                                    onChange={this.onChangeFieldProducto}
                                                    value={formProducto.nombreDocumentoContrato}
                                                    type="text"
                                                    required
                                                />

                                                <FormText color="muted">
                                                    Introduzca el nombre del documento formato PDF necesario para generar el contrato
                                            </FormText>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row>


                                        <Col md="6" sm="12" lg="6">
                                            <FormGroup>
                                                <Label
                                                    className="form-control-label"
                                                    htmlFor="infoAdicional"
                                                >
                                                    INFORMACION ADICIONAL
                                                </Label>
                                                <Input
                                                    id="infoAdicional"
                                                    name="infoAdicional"
                                                    type="textarea"
                                                    style={{
                                                        resize: "none"
                                                    }}
                                                    value={formProducto.infoAdicional}
                                                    onChange={this.onChangeFieldProducto}
                                                ></Input>
                                                <FormText color="muted">
                                                    Introduzca la información que desee que se refleje como información para el agente o consumidor
                                            </FormText>
                                            </FormGroup>
                                        </Col>

                                        <Col md="6" sm="12" lg="6">
                                            <FormGroup>
                                                <Label
                                                    className="form-control-label"
                                                    htmlFor="caracteristicas"
                                                >
                                                    CARACTERISTICAS
                                                </Label>
                                                <Input
                                                    id="caracteristicas"
                                                    name="caracteristicas"
                                                    type="textarea"
                                                    style={{
                                                        resize: "none"
                                                    }}
                                                    value={formProducto.caracteristicas}
                                                    onChange={this.onChangeFieldProducto}
                                                ></Input>
                                                <FormText color="muted">
                                                    Introduzca las características que desee que se refleje como información para el agente o consumidor
                                            </FormText>
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                </CardBody>
                            </Card>

    {this.state.alert}
                        </div>
                    </Row>
                </Container>

            </>
        );
    } else {
      return (
        <>
          <Header title={"No tienes permisos para acceder a este apartado. Consulte con nuestro equipo comercial"}/>
        </>
      );
    }
    }
}


export default withApollo(Producto);
